import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CustomerEventModel } from '@admin/customers/shared/models/customer-event-model';
import { ActionResultModel } from '@admin/shared/models/action-result-model';
import { CustomerAddEventModel } from '@admin/customers/shared/models/customer-add-event-model';
import { CustomerService } from '@admin/customers/shared/services/customer.service';
import { StoreItemModel } from '@admin/product-purchases/shared/models/store-item-model';
import { CommonLookupItem } from '@admin/shared/models/common-lookup-item.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'hr-customer-request-event-cv-db-access',
  templateUrl: './customer-request-event-cv-db-access.component.html',
  styleUrls: ['./customer-request-event-cv-db-access.component.less'],
  standalone: false,
})
export class CustomerRequestEventCvDbAccessComponent implements OnInit {
  @Input()
  public display: boolean;
  // @Input()
  // public customer: number;
  @Input()
  public event: CustomerEventModel;

  @Input()
  public items: StoreItemModel[];

  @Output()
  public onUpdate: EventEmitter<ActionResultModel> =
    new EventEmitter<ActionResultModel>();

  public selectedItem: number;

  // public events: any[];

  // public packages: any[];

  // public selectedEvent: number;
  // public selectedPackage: number;
  // public date: Date;

  public innerMsg: string;

  constructor(
    private customerService: CustomerService,
    private translateService: TranslateService
  ) {
    // this.events = [];
    // this.packages = [];
    // this.date = null;
  }

  onEventChange() {
    // this.packages = [];
    // this.initPackages();
  }

  onSave() {
    if (this.selectedItem == null) {
      this.innerMsg = this.translateService.instant(
        'message.PleaseFillAllFields'
      );
      return;
    }

    this.customerService
      .requestCvDatabaseAccess(this.event.eventParticipantId, this.selectedItem)
      .subscribe((d) => {
        this.finish(d, d.success);
      });

    // let submitData = new CustomerAddEventModel();
    // submitData.customerId = this.customer;
    // submitData.eventId = this.selectedEvent;
    // submitData.packageId = this.selectedPackage;
    // submitData.date = this.date;

    // this.customerService.addEvent(submitData).subscribe(result => {
    //   this.finish(result, result.success);
    // });
  }

  onCancel() {
    this.finish(null);
  }

  onHide() {
    this.finish(null, false);
  }

  // isAlreadyRegistered(event: CommonLookupItem<number, string>) {
  //   //return this.registeredEvents && this.registeredEvents.some(re => re.eventId == event.value);
  // }

  ngOnInit() {
    // this.initEvents();
  }

  // private initEvents() {
  //   this.customerService.listActiveEvents().subscribe(e => {
  //     this.events = e;
  //   });
  // }

  // private initPackages() {
  //   this.customerService.listEventPackages(this.selectedEvent).subscribe(p => {
  //     this.packages = p;
  //   });
  // }

  private finish(result: ActionResultModel, reset: boolean = true) {
    if (reset) {
      this.innerMsg = null;
      this.selectedItem = null;
      // this.selectedEvent = null;
      // this.selectedPackage = null;
      // this.date = null;
    }
    this.onUpdate.emit(result);
  }
}
